<template>
    <router-link
        :tag="tag"
        :to="{name: `terminal.${route}`}"
        class="a-back-button back-button"
    >
        <svg-icon
            v-if="theme === 'home'"
            original
            name="icons/home"
            class="back-button__icon-home"
        />
        <svg-icon
            v-else
            original
            name="icons/back-icon"
            class="back-button__icon"
        />
        {{ text }}
    </router-link>
</template>

<script>
export default {
    name: 'ABackButton',
    props: {
        tag: {
            type: String,
            default: 'a'
        },
        route: {
            type: String,
            default: 'start'
        },
        text: {
            type: String,
            default: 'Back button'
        },
        theme: {
            type: String,
            default: ''
        }
    }
}
</script>

<style lang="scss">
@import "a-back-button";
</style>
